<template>
    <fieldset class="form-item">
        <div class="form-flex">
            <label for="bsnNum" class="form-label form-label-required">사업자등록번호</label>
            <input type="tel" class="form-control" :class="{'warning': !isVaildInputOfBsnNumber}" id="bsnNum" ref="bsnNum" placeholder="사업자등록번호를 입력해주세요" 
                v-model="tempBsnNum" @blur="confirmVaildBsnNumber" @keypress.enter.prevent="sendCertBsnNum">
            <button type="button" class="btn-m" @click.prevent="sendCertBsnNum" :disabled="tempIsNiceApiInfo === 'Y'"><strong>사업자정보 조회</strong></button>
            <!-- <button type="button" class="btn-m" @click.prevent="sendCertBsnNum" :disabled="isInvited || tempIsVaildInputAllBsnValues"><strong>사업자정보 조회</strong></button> -->
            <!-- 유효성 검사 안내 메시지 -->
            <p v-show="messageBsnNumber" class="form-info" :class="{'active': messageBsnNumber}">{{messageBsnNumber}}</p>
        </div>
        
    <template v-if="$route.name.match('profile-info') || ($route.name.match('join') && isOpenable)">
        <!-- 회원가입 페이지는 사업장 정보 조회 api 요청 완료 후 표출 -->

        <div class="form-flex">
            <label for="bsnTitle" class="form-label form-label-required">상호명</label>
            <template v-if="this.tempIsNiceApiInfo === 'Y'">
                <!-- NICE API에서 사업자정보 있을 경우 readOnly -->
                <p class="form-control readonly">{{tempBsnTitle}}</p>
            </template>
            <template v-else>
                <input type="text" class="form-control" id="bsnTitle" ref="bsnTitle" placeholder="사업자 조회 시, 상호명이 자동입력됩니다." 
                    v-model="tempBsnTitle" @blur="confirmVaildBsnTitle">
            </template>
        </div>
        <!-- 유효성 검사 안내 메시지 -->
        <p v-show="messageBsnTitle" class="form-info" :class="{'active': messageBsnTitle}">{{messageBsnTitle}}</p>

        <div class="form-flex">
            <label for="bsnTitle" class="form-label form-label-required">대표자명</label>
            <template v-if="this.tempIsNiceApiInfo === 'Y'">
                <!-- NICE API에서 사업자정보 있을 경우 readOnly -->
                <p class="form-control readonly">{{tempBsnOwner}}</p>
            </template>
            <template v-else>
                <input type="text" class="form-control" id="bsnOwner" placeholder="사업자 조회 시, 대표자명이 자동입력됩니다." 
                v-model="tempBsnOwner" @blur="confirmVaildBsnOwner">
            </template>
            <!-- 유효성 검사 안내 메시지 -->
            <p v-show="messageBsnOwner" class="form-info" :class="{'active': messageBsnOwner}">{{messageBsnOwner}}</p>
        </div>
    </template>

        <!-- 사업자 폼 값들 전체 유효성 검사 안내 메시지 -->
        <p v-show="tempMessageAllBsnValues" class="form-info" :class="{'active': tempMessageAllBsnValues, 'success': messageSuccess}">{{tempMessageAllBsnValues}}</p>
    </fieldset>
</template>

<script>
import { mapState } from 'vuex';
export default {
    components: {
    },

    props:{
        messageAllBsnValues: {        // 유효성 검사 메시지 - 회원가입 실패 사유 (회원가입, 회원정보수정 props)
            type: String,
            default: '',
        },
        businessProfileInfo: {     // fetch User 정보 객체 (회원정보수정 props)
            type: Object
        }
    },

    data() {
        return {
            isInvited: false,                               // 기업관리자의 초대 여부

            bsnNum: '',                                     // 사업자등록번호
            bsnTitle: '',                                   // 상호명
            bsnOwner: '',                                   // 사업자 대표명
            isNiceApiInfo: 'N',                             // NICE api에 존재하는 사업자정보 여부
            isVaildInputAllBsnValues: false,

            tempBsnNum: this.bsnNum,                        // 사업자등록번호 입력값
            tempBsnTitle: this.bsnTitle,                    // 상호명 입력값
            tempBsnOwner: this.bsnOwner,                    // 사업자 대표명 입력값
            tempIsNiceApiInfo: this.isNiceApiInfo,          // 입력값 조회 이후 NICE api에 존재하는 사업자정보 여부
            tempIsVaildInputAllBsnValues: this.isVaildInputAllBsnValues,  // 입력값의 사업자정보 업데이트 가능 유효 여부
            tempMessageAllBsnValues: this.messageAllBsnValues,    // 입력값의 사업자정보 업데이트 가능 유효성 검사 메시지

            regExpBsnNum: /^(\d{3}-\d{2}-\d{5}|\d{10})$/,   // 사업자등록번호 정규식
            regExpBsnTitle: /^[가-힣a-zA-Z()]+$/,           // 상호명 정규식
            regExpBsnOwner: /^[가-힣a-zA-Z,]+$/,            // 대표자명 정규식

            isVaildInputOfBsnNumber: false,                 // 사업자등록번호 입력값 유효 여부
            isVaildInputOfBsnTitle: false,                  // 상호명 입력값 유효 여부
            isVaildInputOfBsnOwner: false,                  // 대표자명 유효 여부
            messageBsnNumber: false,                        // 사업자등록번호 유효성 검사 메시지
            messageBsnTitle: false,                         // 상호명 입력값 유효성 검사 메시지
            messageBsnOwner: false,                         // 대표자명 유효성 검사 메시지

            messageSuccess: false,                          // 유효성 메시지 속성 - 성공
            isInputReadOnly: false,

            isOpenable: false,                              // 사업자정보 조회 여부
            apiBsnRegistResult: {                           // 사업자정보 조회 API 결과 데이터
                compName: '',
                compNum: '',
                representiveName: '',
                resultCd: '',
                rspCd: '',
                isNiceApiInfo: 'N'
            },
            
            bsnFile: null,                                  // 사업자 등록증 파일
            messageBsnFile: '',                             // 사업자인증 파일 유효성 검사 메시지
        }
    },

    computed: {
        ...mapState({
            userNo: state => state.userNo,
            authentication: state => state.authentication
        }),
    },

    mounted() {
        this.setBusinessProfileInfo();
    },

    watch: {
        tempIsVaildInputAllBsnValues(){
            if(this.tempIsVaildInputAllBsnValues){
                this.sendValueToParent();
            }else{
                this.sendValueToParent();
            }
        },

        tempBsnNum(){            
            // if(this.tempBsnNum !== this.bsnNum){ // 초기화
            //     this.tempIsNiceApiInfo = 'N';
            //     this.tempIsVaildInputAllBsnValues = false;
            // }
            this.initByEditBsnNumber();
            this.confirmVaildBsnInputValues();
        },

        messageAllBsnValues(){ // 부모페이지 유효성 검사 메시지 변화 감지
            this.tempMessageAllBsnValues = this.messageAllBsnValues;
        },

        isVaildInputOfBsnNumber(){
            this.confirmVaildBsnInputValues();
        },
        isVaildInputOfBsnTitle(){
            this.confirmVaildBsnInputValues();
        },
        isVaildInputOfBsnOwner(){
            this.confirmVaildBsnInputValues();
        },
    },

    methods: {
        // 회원정보 페이지에서 저장된 사업자정보 세팅
        setBusinessProfileInfo(){
            if(this.$route.name.match('profile-info')){
                this.tempBsnNum = this.bsnNum = this.businessProfileInfo.bsnNum;
                this.tempBsnTitle = this.bsnTitle = this.businessProfileInfo.bsnTitle;
                this.tempBsnOwner = this.bsnOwner = this.businessProfileInfo.bsnOwner;
                this.tempMessageAllBsnValues = this.messageAllBsnValues = this.businessProfileInfo.messageAllBsnValues;
                this.tempIsVaildInputAllBsnValues = this.isVaildInputAllBsnValues = this.businessProfileInfo.isVaildInputAllBsnValues;
                this.tempIsNiceApiInfo = this.isNiceApiInfo = this.businessProfileInfo.isNiceApiInfo;

                if(this.isVaildInputAllBsnValues){
                    this.isVaildInputOfBsnNumber = true;
                    this.isVaildInputOfBsnTitle = true;
                    this.isVaildInputOfBsnOwner = true;                
                }

                // 메시지 안내
                if(this.isNiceApiInfo === 'N' && this.isVaildInputAllBsnValues){
                    this.messageSuccess = true;
                }
                if(this.isNiceApiInfo === 'N' && !this.isVaildInputAllBsnValues){
                    this.messageSuccess = false;
                }
            }
        },

        // 부모 컴포넌트에 데이터 전달하기
        sendValueToParent(){ // 가장 자주 전달이 필요한 안내 메시지만 파라미터로 설정
            this.$emit('updateBsnDatas', {
                'bsnNum': this.tempBsnNum,
                'bsnTitle': this.tempBsnTitle,
                'bsnOwner': this.tempBsnOwner,
                'isVaildInputAllBsnValues': this.tempIsVaildInputAllBsnValues,
                'messageAllBsnValues': this.tempMessageAllBsnValues,
                'isNiceApiInfo': this.tempIsNiceApiInfo
            });
        },

        // 사업자 가입 유효성 검사
        confirmVaildBsnInputValues(){
            this.isVaildInputOfBsnNumber && this.isVaildInputOfBsnTitle && this.isVaildInputOfBsnOwner ? this.tempIsVaildInputAllBsnValues = true : this.tempIsVaildInputAllBsnValues = false;
        },

        // 사업자번호 유효성검사
        confirmVaildBsnNumber(){
            this.initByEditBsnNumber(); // 초기화

            if (!this.tempBsnNum) {
                this.isVaildInputOfBsnNumber = false;
                this.messageSuccess = false;
                this.messageBsnNumber = '사업자등록번호 10자리를 입력해주세요.';
                this.sendValueToParent();
                return;
            }
            
            this.tempBsnNum = this.tempBsnNum.replace(' ', ''); // 공백제거
            this.deleteCharacter(); // 특수문자 제거

            if (!this.regExpBsnNum.test(this.tempBsnNum)) {
                this.isVaildInputOfBsnNumber = false;
                this.messageSuccess = false;
                this.messageBsnNumber = '사업자등록번호 10자리를 형식에 맞게 입력해주세요.';
                this.sendValueToParent();
                return;
            }

            this.isVaildInputOfBsnNumber = true;
            this.messageBsnNumber = "";
            this.messageSuccess = true;
            this.sendValueToParent();
        },

        // 문자 및 특수문자 제거
        deleteCharacter(){
            if(this.tempBsnNum){
                this.tempBsnNum = this.tempBsnNum.replace(/[^\d]/ig, ""); // 하이픈(-) 제거
            }
        },

        // 사업자번호 수정으로 초기화
        initByEditBsnNumber(){
            if(this.tempBsnNum !== this.bsnNum){
                this.tempIsNiceApiInfo = 'N';
                this.tempIsVaildInputAllBsnValues = false;
                this.isVaildInputOfBsnNumber = false;
                this.isVaildInputOfBsnTitle = false;
                this.isVaildInputOfBsnOwner = false;
                this.tempBsnTitle = '';
                this.tempBsnOwner = '';
                this.messageBsnNumber = '';
                this.messageBsnTitle = '';
                this.messageBsnOwner = '';
                this.tempMessageAllBsnValues = '';
            }else if(this.bsnNum && (this.tempBsnNum === this.bsnNum)){
                this.tempBsnTitle = this.bsnTitle;
                this.tempBsnOwner = this.bsnOwner;
                this.confirmVaildBsnTitle(); // 상호명 유효성 검사
                this.confirmVaildBsnOwner(); // 대표자명 유효성 검사
                this.confirmVaildBsnInputValues();  // 사업자정보 업데이트 가능 유효성 검사                
                this.tempMessageAllBsnValues = this.messageAllBsnValues;
                this.tempIsVaildInputAllBsnValues = this.isVaildInputAllBsnValues;
                this.tempIsNiceApiInfo = this.isNiceApiInfo;

                if(this.tempIsNiceApiInfo === 'N' && this.isVaildInputAllBsnValues){
                    this.tempMessageAllBsnValues = '사업자등록 상태 조회가 되지 않는 사업자 정보입니다';
                }
                else{
                    this.businessProfileInfo.messageAllBsnValues = '사업자정보를 입력해주세요.';
                }                
            }
            this.sendValueToParent();
        },

        // 상호명 유효성검사
        confirmVaildBsnTitle(){
            if(!this.tempBsnTitle){
                this.isVaildInputOfBsnTitle = false;
                this.tempMessageAllBsnValues = '';
                this.messageSuccess = false;
                this.messageBsnTitle = '상호명을 입력해주세요.';
                this.sendValueToParent();
                return;
            }

            if(!this.regExpBsnTitle.test(this.tempBsnTitle)){
                this.isVaildInputOfBsnTitle = false;
                this.tempMessageAllBsnValues = '';
                this.messageSuccess = false;
                this.messageBsnTitle = '유효한 상호명을 입력해주세요. (띄어쓰기 불가)';
                this.sendValueToParent();
                return;
            }
            this.isVaildInputOfBsnTitle = true;
            this.messageBsnTitle = "";
            this.messageSuccess = true;
            this.sendValueToParent();
        },

        // 대표자명 유효성검사
        confirmVaildBsnOwner(){
            if(!this.tempBsnOwner){
                this.isVaildInputOfBsnOwner = false;
                this.tempMessageAllBsnValues = '';
                this.messageSuccess = false;
                this.messageBsnOwner = '대표자명을 입력해주세요.';
                this.sendValueToParent();
                return;
            }

            if(!this.regExpBsnOwner.test(this.tempBsnOwner)){
                this.isVaildInputOfBsnOwner = false;
                this.tempMessageAllBsnValues = '';
                this.messageSuccess = false;
                this.messageBsnOwner = '유효한 대표자명을 입력해주세요. (띄어쓰기 불가)';
                this.sendValueToParent();
                return;
            }

            this.isVaildInputOfBsnOwner = true;
            this.messageSuccess = true;
            this.messageBsnOwner = '';
            this.sendValueToParent();
        },
        
        // 요소에 접근하여 포커싱하기
        focusOnWarning(element, className){
            element.focus();
            if(className === 'warning'){
                element.classList.add(className);
            }
        },

        // 사업자등록번호 인증 버튼 클릭: 인증 API 호출
        sendCertBsnNum() {

            // 사업자번호 유효성 검사    
            this.confirmVaildBsnNumber();
            if(!this.isVaildInputOfBsnNumber){
                this.focusOnWarning(this.$refs.bsnNum, 'warning');
                return;
            }

            this.dispatchCheckCompanyInfo();
        },

        async dispatchCheckCompanyInfo() {
            try {
                const data = {
                    comp_num : this.tempBsnNum ,
                    userNo: this.userNo
                }

                const response = await this.$store.dispatch(
                    'companyStore/acitonsCheckCompanyInfoApi', data
                );
                
                this.tempIsNiceApiInfo = 'Y';
                this.apiBsnRegistResult = response.data;
                this.handleResposeValue();
            } catch(err) {
                this.tempIsNiceApiInfo = 'N';
                this.messagePassword = err.response.data.message;
                alert(err.response.data.message);
                return;
            } finally {
                this.isOpenable = true;
                this.messageBsnNumber = "";
                this.messageBsnTitle = "";
                this.messageBsnOwner = '';
            }
        },

        // 사업자등록 조회 응답값 핸들링
        handleResposeValue() {
            this.tempBsnTitle = this.apiBsnRegistResult.compName;
            this.tempBsnOwner = this.apiBsnRegistResult.representiveName;
            this.tempBsnNum = this.apiBsnRegistResult.compNum;            
            this.tempIsNiceApiInfo = this.apiBsnRegistResult.isNiceApiInfo;
            
            if(this.tempIsNiceApiInfo === 'Y'){
                this.isVaildInputOfBsnTitle = true; // 상호명 유효성 통과
                this.isVaildInputOfBsnOwner = true; // 대표자명 유효성 통과
                this.tempIsVaildInputAllBsnValues = true; // 사업자정보 유효성 통과
                this.messageSuccess = true;
                this.tempMessageAllBsnValues = '사업자등록번호 조회를 성공하였습니다.';
            }else{
                this.confirmVaildBsnTitle(); // 상호명 유효성 검사
                this.confirmVaildBsnOwner(); // 대표자명 유효성 검사
                this.confirmVaildBsnInputValues();  // 사업자정보 업데이트 가능 유효성 검사
                this.messageSuccess = false;
                this.tempMessageAllBsnValues = '사업자등록번호 조회를 실패하였습니다. 사업자정보를 직접 입력할 수 있습니다.';
            }
            this.sendValueToParent();
        },

        // 사업자 파일 업로드 - 회원가입 과정에서 제외
        // selectBsnFile(event) {
        //     const elBsnFile = document.querySelector('.file-view');

        //     if (event.target.files.length > 0) {
        //         const file = event.target.files[0];
        //         const fileExt = file.type.split("/")[1];
        //         elBsnFile.value = event.target.files[0].name; //파일 이름 노출

        //         if (/jpg|jpeg|pdf/gi.test(fileExt)) {
        //             this.bsnFile = event.target.files[0];
        //             this.messageBsnFile = '';
        //         } else {
        //             elBsnFile.classList.add('warning');
        //             elBsnFile.focus();
        //             this.messageBsnFile = 'pdf, jpg 파일만 업로드 가능합니다.';

        //             event.target.value = "";
        //             this.bsnFile = null;
        //         }
        //     } else {
        //         event.target.value = "";
        //         this.bsnFile = null;
        //     }
        // },
    }
}
</script>

<style>
</style>